import { createBuiltInComponentMeta, withComponentMeta } from '../../internal/component-meta';
import { Stack as StackComponent } from './Stack';
import { StackCol as StackColComponent } from './StackCol';
import { StackRow as StackRowComponent } from './StackRow';
export const Stack = withComponentMeta(StackComponent, createBuiltInComponentMeta('Stack'));
export const StackRow = withComponentMeta(StackRowComponent, createBuiltInComponentMeta('StackRow'));
export const StackCol = withComponentMeta(StackColComponent, createBuiltInComponentMeta('StackCol'));
//# sourceMappingURL=index.js.map